import { GetSearchBarResults } from 'constants/routes';
import { fromFetch } from 'rxjs/fetch';
import { switchMap, of, catchError } from 'rxjs';

/**
 * Fetches the search bar results for a given search text.
 * @param {string} searchText - The search text to fetch results for.
 * @returns {Observable<Object>} An observable that emits the search results or an error object.
 */
function getSearchBarResults$(searchText) {
    const url = `${GetSearchBarResults}?searchterm=${searchText}`;

    return fromFetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    }).pipe(
        switchMap((response) => {
            if (response.ok) {
                return response.json();
            }
            return of({
                error: true,
                message: 'Error fetching data',
            });
        }),
        catchError((error) =>
            of({
                error: true,
                message: error.message,
            })
        )
    );
}

export default getSearchBarResults$;